import React from 'react';
import PropTypes from 'prop-types';
import {
  matchPath, Redirect, Route, withRouter,
} from 'react-router-dom';
import app from 'new-ui/app';
import { getLocalStorageUser } from 'functions/getLocalStorageUser';
import { formRoutePath } from 'functions/formRoutePath';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { REDIRECT_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { useIsPreliminaryAuth } from 'utils/hooks/useIsPreliminaryAuth';
import { useAuth } from 'utils/hooks/useAuth';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const loggedIn = useIsPreliminaryAuth();
  const { isAuthPending } = useAuth();

  const { location } = window;

  if (!loggedIn && !getLocalStorageUser()) {
    const { location: { pathname, search } } = rest;

    let redirectTo;
    const pathsToRedirect = [
      { path: ROUTE_PATH[ROUTE_NAME.TRIAL], targetPath: ROUTE_PATH[ROUTE_NAME.PUBLIC_TRIAL] },
      { path: ROUTE_PATH[ROUTE_NAME.TREATMENT], targetPath: ROUTE_PATH[ROUTE_NAME.PUBLIC_TREATMENT] },
    ];
    for (const { path, targetPath } of pathsToRedirect) {
      const match = matchPath(pathname, {
        path,
        exact: true,
      });
      if (match) {
        const { params: { nctNumber } } = match;
        redirectTo = formRoutePath(targetPath, { nctNumber });
        if (search) {
          redirectTo += search;
        }
        break;
      }
    }

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    localStorage.clear();

    const params = new URLSearchParams(window.location.search);
    params.append(REDIRECT_URL_SEARCH_PARAM, location.pathname);

    window.location = `${ROUTE_PATH[ROUTE_NAME.LOGIN]}?${params.toString()}`;
    return null;
  }
  if (isAuthPending && !app.isCurrentPage(ROUTE_NAME.CHAT)) {
    return null;
  }
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(PrivateRoute);
